var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        size: "960px",
        title: _vm.$t("pc_gwnl_global_modelSets"),
        visible: _vm.show,
        "before-close": _vm.beforeDrawClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-model-selector" },
        [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("attribute-selector", {
                staticClass: "mr12",
                attrs: {
                  placeholder: _vm.$t("gwnl_gwnl_pc_model_attribute"),
                  list: _vm.attributeOptions,
                },
                on: {
                  change: function ($event) {
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.selectedAttribute,
                  callback: function ($$v) {
                    _vm.selectedAttribute = $$v
                  },
                  expression: "selectedAttribute",
                },
              }),
              _c("attribute-selector", {
                staticClass: "mr12",
                attrs: {
                  placeholder: _vm.$t("gwnl_gwnl_pc_model_hierarchical"),
                  list: _vm.applicationLevelOptions,
                },
                on: {
                  change: function ($event) {
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.selectedApplication,
                  callback: function ($$v) {
                    _vm.selectedApplication = $$v
                  },
                  expression: "selectedApplication",
                },
              }),
              _c("yxt-input", {
                staticClass: "mb16",
                staticStyle: { width: "240px" },
                attrs: {
                  placeholder: _vm.$t("pc_gwnl_jq_pleaseEnterLabelName", {
                    prefixLabel: _vm.prefixLabel,
                  }),
                  size: "small",
                  searchable: "",
                },
                on: {
                  search: function ($event) {
                    return _vm.search(1)
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
            ],
            1
          ),
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              attrs: { "row-key": "id", data: _vm.list },
            },
            [
              _c("yxt-table-column", {
                attrs: {
                  prop: "name",
                  "min-width": "300",
                  label: _vm.$t("pc_gwnl_model_template__table_column_name"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "gwnl__skill-name cursor-pointer" },
                          [
                            _c(
                              "yxt-popover",
                              {
                                attrs: {
                                  effect: "dark",
                                  trigger: "hover",
                                  "popper-class": "gwnl-jq-create-popper",
                                  placement: "top",
                                  "max-width": "280",
                                  "max-height": "144",
                                  "show-scroll": "",
                                  "open-filter": true,
                                  content: row.name,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ellipsis",
                                    staticStyle: { "max-width": "280px" },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(row.name || "--") +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            row.cloudType
                              ? _c(
                                  "yxt-tag",
                                  {
                                    staticClass: "ml14",
                                    attrs: { size: "mini" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("pc_gwnl_global_tag_cloud")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !row.enableSkillLevel
                              ? _c(
                                  "yxt-tag",
                                  {
                                    staticClass: "ml8",
                                    attrs: { size: "mini", type: "warning" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("pc_gwnl_global_tag_noLevel")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  prop: "attributeName",
                  width: "104",
                  label: _vm.$t("pc_gwnl_global_lbl_modelprop"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.attributeName || "--") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  prop: "hierarchicalName",
                  "min-width": "90",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("gwnl_gwnl_pc_model_hierarchical"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.hierarchicalName || "--") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  width: "160px",
                  label: _vm.$t("pc_gwnl_global_lbl_operate"),
                  fixed: "right",
                  "hide-column": "disable",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.previewTemplate(scope.row.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("pc_gwnl_global_btn_preview")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c("yxt-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSelectTemplate(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.selectedId === scope.row.id
                                    ? _vm.$t("pc_gwnl_global_deselect")
                                    : _vm.$t("pc_gwnl_global_select")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c("pager", {
                attrs: { pager: _vm.pager },
                on: { searchData: _vm.search },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("yxt-button", { attrs: { plain: "" }, on: { click: _vm.close } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_gwnl_global_msg_cancel")) +
                "\n    "
            ),
          ]),
          _c(
            "yxt-button",
            {
              attrs: {
                type: "primary",
                disabled: !_vm.selectedId && _vm.type !== 2 && _vm.type !== 3,
              },
              on: { click: _vm.handleConfirm },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_global_msg_determine")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }